import { render, staticRenderFns } from "./allpushform.vue?vue&type=template&id=c2dc72c6&scoped=true&"
import script from "./allpushform.vue?vue&type=script&lang=js&"
export * from "./allpushform.vue?vue&type=script&lang=js&"
import style0 from "./allpushform.vue?vue&type=style&index=0&id=c2dc72c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2dc72c6",
  null
  
)

export default component.exports